import { useEffect, useRef } from "react";
import api from "../lib/api";
import useAuthStore from "../store/authStore";
import useWishlistStore from "../store/wishlistStore";

// Runs once per sign-in: pulls the account's server-side wishlist into
// the local store (mergeIds is additive, so anything already saved here
// isn't lost), then pushes up any local-only ids — items a guest saved
// before logging in — so nothing from either side is silently dropped.
export default function useWishlistSync() {
  const status = useAuthStore((s) => s.status);
  const syncedFor = useRef(null);

  useEffect(() => {
    if (status !== "authenticated" || syncedFor.current === status) return;
    syncedFor.current = status;

    (async () => {
      try {
        const { data } = await api.get("/wishlist");
        const serverIds = data.productIds ?? [];
        useWishlistStore.getState().mergeIds(serverIds);

        const localIds = useWishlistStore.getState().productIds;
        const toPush = localIds.filter((id) => !serverIds.includes(id));
        await Promise.all(
          toPush.map((id) => api.post("/wishlist", { productId: id }).catch(() => {}))
        );
      } catch {
        // Best-effort — sync failing just leaves the wishlist client-only
        // for this session instead of breaking anything visible.
      }
    })();
  }, [status]);
}
